import QuoteCard from './quote-card'

export type { QuoteCardProps } from './quote-card'

export { QuoteCard }
